import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  HeaderThree,
  TextLink,
  CreateClassIcon,
  AwardIcon,
} from 'secondstep-components'

export const LinksGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding-top: 1.25rem;
  margin: 0 0.625rem;
  border-top: 1.5px solid ${themeGet('colors.gray500')};

  ${TextLink} {
    font-weight: 500;
  }
`

export const StyledHeaderThree = styled(HeaderThree)`
  line-height: 1.125rem !important;
  margin: 0.625rem 0.625rem 0.375rem !important;
`
// FirstTimeClasses styled components
export const ClassesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 1.25rem;

  ${themeGet('breakpoints.medium')} {
    flex-direction: column;
  }
`

export const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('firstTimeClasses.titleColor')};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-bottom-color: #eef0f2;
  padding-bottom: 0.5rem;
`

export const StyledButton = styled.button`
  width: 18.5rem;
  height: 3.063rem;
  border-radius: 0.625rem;
  border: none;
  cursor: pointer;
  color: ${themeGet('firstTimeClasses.button.color')};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  &:hover {
    color: ${themeGet('firstTimeClasses.button.hoverColor')};
  }
`

export const StyledCreateClassIcon = styled(CreateClassIcon)`
  width: 1.125rem;
  height: 1.125rem;
  margin-left: 0.625rem;
  color: ${themeGet('firstTimeClasses.button.color')};
  transition: color 0.2s ease;

  circle {
    fill: currentColor;
  }

  ${StyledButton}:hover & {
    color: ${themeGet('firstTimeClasses.button.hoverColor')};
  }
`

export const StyledAwardIcon = styled(AwardIcon)`
  width: 0.938rem;
  height: 1.313rem;
  margin-left: 0.625rem;
  color: ${themeGet('firstTimeClasses.button.color')};
  transition: color 0.2s ease;

  ${StyledButton}:hover & {
    color: ${themeGet('firstTimeClasses.button.hoverColor')};
  }
`

export const HiddenCreateCourseContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
`

// Custom styles for the tiles-container class
export const TilesContainerWrapper = styled.div`
  .tiles-container {
    padding: 0 !important;
  }
`
